<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">商户类型</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="商户类型">
            <el-input v-model="BusinessType" placeholder="请输入商户类型" clearable></el-input>
          </el-form-item>
          <el-form-item class="right">
            <el-button @click="onSearch">查 询</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="BusinessTypeName" label="商户类型"></el-table-column>
              <el-table-column fixed="right" label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="queryClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button
                    @click="deleteClick(scope.$index,scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5,10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <BusinessTypeInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :BusinessType_Id="SelectedBusinessTypeId"
        :IsEdit="isEdit"
      ></BusinessTypeInfoPage>
    </ZjDialog>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";
import BusinessTypeInfoPage from "./businesstypeinfo.vue";

export default {
  name: "BusinessTypePage",
  controller: "UI",
  action: "BusinessTypes",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      Orgs: null,
      BusinessType: "",
      tableHeight: window.innerHeight - 440,
      dilaogconfig: {
        title: "添加商户类型",
        dialogFormVisible: false,
        width: "900px",
      },
      multipleSelection: [],
      isEdit: true,
    };
  },
  components: {
    BusinessTypeInfoPage,
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
    this.init();
  },
  mounted: function () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.tableHeight = window.innerHeight - 440;
      })();
    };
    this.GetBusinessTypes();
    this.logInfo.ActionName = "商户类型列表查看";
    this.logInfo.LogMessage = "商户类型列表查看";
    this.logInfo.ModuleName = "统一管理";
    this.logInfo.PageName = "商户类型列表";
    this.addOperationLog();
  },
  computed: {},
  methods: {
    // 初始化
    init() {
      return utils.waitAll([() => this.GetBusinessTypes()]);
    },
    GetBusinessTypes() {
      showLoading(".zj-table-container");

      let BusinessTypeSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        BusinessTypeName: this.BusinessTypeName,
        TotalCount: 0,
      };

      console.log(BusinessTypeSearch);
      return new WebApis.BusinessTypeApi()
        .GetPageContentByConditions(BusinessTypeSearch)
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户类型数据异常！" + e.RspMsg
              : "获取商户类型数据异常！",
            type: "error",
          });
          hideLoading();
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage=1;
      this.GetBusinessTypes();
    },
    clearsearch() {
      this.BusinessTypeName = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.GetBusinessTypes();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetBusinessTypes();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetBusinessTypes();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    onAdd() {
      this.SelectedBusinessTypeId = "";
      this.isEdit = true;
      this.dilaogconfig.dialogFormVisible = true;
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    onbatchDel() {
      let BusinessType_Ids = [];
      this.multipleSelection.forEach((item) => {
        BusinessType_Ids.push(item.LogicId);
      });

      if (BusinessType_Ids.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择要删除的数据!",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定删除选中商户类型?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let BusinessTypeSearch = {
          BusinessTypeIds: BusinessType_Ids,
        };
        console.log(BusinessTypeSearch);
        const that = this;
        that.canDelete(that.multipleSelection, function (data) {
          const index = data.findIndex((item) => item.isDelete == false);
          if (index == -1 && data.length == BusinessType_Ids.length) {
            new WebApis.BusinessTypeApi()
              .DelItemList(BusinessTypeSearch)
              .then((r) => {
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "删除成功!" });
                  that.GetBusinessTypes();
                } else {
                  that.$message({
                    showClose: true,
                    message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                    type: "error",
                  });
                }
                that.logInfo.ActionName = "商户类型删除";
                that.logInfo.LogMessage =
                  r.RspCode == "1" ? "商户类型删除成功" : "删除商户类型失败";
                that.logInfo.ModuleName = "统一管理";
                that.logInfo.PageName = "商户类型管理列表页面";
                that.addOperationLog();
              })
              .catch((e) => {
                that.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "删除失败!" + e.RspMsg
                    : "获取商户类型信息失败!",
                  type: "error",
                });
              });
          } else {
            return;
          }
        });
      });
    },
    queryClick(index, row) {
      this.SelectedBusinessTypeId = row.BusinessTypeId;
      this.isEdit = false;
      this.dilaogconfig.title = "查看商户类型";
      this.dilaogconfig.dialogFormVisible = true;
    },
    editClick(index, row) {
      this.SelectedBusinessTypeId = row.BusinessTypeId;
      this.isEdit = true;
      this.dilaogconfig.title = "修改商户类型";
      this.dilaogconfig.dialogFormVisible = true;
    },
    deleteClick(index, row) {
      this.SelectedBusinessTypeId = row.BusinessTypeId;
      this.$confirm("确定删除该商户类型?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const that=this;
        let BusinessTypeSearch = {
          BusinessTypeId: this.SelectedBusinessTypeId,
        };
         new WebApis.BusinessTypeApi()
              .DelItem(BusinessTypeSearch)
              .then((r) => {
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "删除成功!" });
                  that.GetBusinessTypes();
                } else {
                  that.$message({
                    showClose: true,
                    message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                    type: "error",
                  });
                }
                that.logInfo.ActionName = "商户类型删除";
                that.logInfo.LogMessage =
                  r.RspCode == "1" ? "商户类型删除成功" : "删除商户类型失败";
                that.logInfo.ModuleName = "统一管理";
                that.logInfo.PageName = "商户类型列表";
                that.addOperationLog();
              })
              .catch((e) => {
                console.log(e);
                that.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "删除失败!" + e.RspMsg
                    : "获取商户类型信息失败!",
                  type: "error",
                });
              });
      });
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetBusinessTypes();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
     //已维护在组织机构中，不能删除
    canDelete(selectData, callback) {
      let arr = [];
      for (let i = 0; i < selectData.length; i++) {
        new WebApis.BusinessApi()
          .FindByConditions({
            BusinessTypeId: selectData[i].BusinessTypeId,
          })
          .then((r) => {
            var data = r.data.Data;
            if (data.length > 0) {
              this.$message.error(
                selectData[i].BusinessTypeName + "已有商家使用，不能删除"
              );
              arr.push({ isDelete: false });
            } else {
              arr.push({ isDelete: true });
            }
            callback(arr);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    }
  }
};
</script>